import { AdaptiveDpr, AdaptiveEvents } from '@react-three/drei';
import { useCamera } from 'modules/editor/hooks/useCamera';
import { useTooltip } from 'modules/editor/hooks/useTooltip';
import { useCanvasAspect } from 'modules/editor/hooks/useCanvasAspect';
import { useSentryGpuContext } from 'modules/editor/hooks/useSentryGpuContext';
import { useMobileInitialCameraPosition } from 'modules/editor/hooks/useMobileInitialCameraPosition';

export function EditorSetup() {
  useCamera();
  useMobileInitialCameraPosition();
  useTooltip();
  useCanvasAspect();
  useSentryGpuContext();

  return (
    <>
      <AdaptiveEvents />
      <AdaptiveDpr pixelated />
    </>
  );
}
